export const DOWNLOADS_BASE_URL = 'https://luminarybs.com/support/prg';

export type ProductDownload = {
  id: string;
  name: string;
  description: string;
  file: string;
  buttonLabel: string;
  productPath: string;
};

export const PRODUCT_DOWNLOADS: ProductDownload[] = [
  {
    id: 'caf',
    name: 'CAF',
    description: 'Hazır giyim ve konfeksiyon yönetimi — DNAsoft CAF.',
    file: 'caf.zip',
    buttonLabel: 'CAF İndir',
    productPath: '/cozumler/dnasoft/caf',
  },
  {
    id: 'kaf',
    name: 'KAF',
    description: 'Endüstriyel profil, metal ve kereste yönetimi — DNAsoft KAF.',
    file: 'kaf.zip',
    buttonLabel: 'KAF İndir',
    productPath: '/cozumler/dnasoft/kaf',
  },
  {
    id: 'probi',
    name: 'ProBI',
    description: 'Kurumsal iş zekası ve dashboard platformu — Windows ve responsive web tabanlı sürüm.',
    file: 'ProBI.zip',
    buttonLabel: 'Windows & Web',
    productPath: '/urunler/probi',
  },
  {
    id: 'probi-win',
    name: 'ProBI.Win',
    description: 'Kurumsal iş zekası ve dashboard platformu — Windows tabanlı sürüm.',
    file: 'ProBI.Win.zip',
    buttonLabel: 'Windows İndir',
    productPath: '/urunler/probi',
  },
  {
    id: 'probank',
    name: 'ProBank',
    description: 'Banka mutabakatı ve MT940 entegrasyonu.',
    file: 'ProBank.zip',
    buttonLabel: 'İndir',
    productPath: '/urunler/probank',
  },
  {
    id: 'prohr',
    name: 'ProHR',
    description: 'İnsan kaynakları ve bordro yönetimi.',
    file: 'ProHR.zip',
    buttonLabel: 'İndir',
    productPath: '/urunler/prohr',
  },
  {
    id: 'promes',
    name: 'ProMES',
    description: 'Üretim takip ve MES.',
    file: 'ProMES.zip',
    buttonLabel: 'İndir',
    productPath: '/urunler/promes',
  },
];

export function getDownloadUrl(file: string): string {
  return `${DOWNLOADS_BASE_URL}/${file}`;
}

export function getDownloadsByProductPath(path: string): ProductDownload[] {
  return PRODUCT_DOWNLOADS.filter((d) => d.productPath === path);
}

export function getDemoDownloadsForPath(path: string): { label: string; href: string }[] {
  return getDownloadsByProductPath(path).map((d) => ({
    label: d.buttonLabel,
    href: getDownloadUrl(d.file),
  }));
}

export function getDownloadById(id: string): ProductDownload | undefined {
  return PRODUCT_DOWNLOADS.find((d) => d.id === id);
}
